import { ErrorMessage } from '@hookform/error-message';
import classNames from 'classnames';
import { FieldValues } from 'react-hook-form';

import { Form, FormControlProps } from '../../../../bootstrap';

type Props = FieldValues & FormControlProps;

/**
 * @deprecated
 * Use `import { ControlledInput } from '@willow/shared-web';`
 */
export function StringInputWithErrorMessage({
  register,
  errors,
  fieldKey,
  name,
  placeholder,
  className,
  ...props
}: Props) {
  return (
    <Form.Group className={className}>
      <Form.Label>{name}</Form.Label>
      <Form.Control
        className={classNames({
          'u-border-color-red1': errors[fieldKey],
        })}
        type="text"
        placeholder={placeholder}
        {...register(fieldKey)}
        autoFocus={props.autoFocus}
      />
      <ErrorMessage
        errors={errors}
        name={fieldKey as any} // Need to cast here b/c type for register vs ErrorMessage are slightly different
        render={({ message }) => <div className="u-fs-2 u-color-red1">{message}</div>}
      />
    </Form.Group>
  );
}
